import { useIssuesOnDocumentation } from 'store/issue';
import { ReactElement } from 'react';
import { IssueCards } from './IssueCards';
import { Slide } from '@mui/material';
import { DocumentationBaseIds } from 'shared/types/documentation';

export function DocumentationIssueCards({
  file,
  visible,
}: {
  file: DocumentationBaseIds;
  visible: boolean;
}): ReactElement | null {
  const { issues, isUsedAsLevel, loadingLevels } = useIssuesOnDocumentation(file);

  const isVisible = !loadingLevels && isUsedAsLevel && visible;

  return (
    <Slide direction='up' in={isVisible} mountOnEnter unmountOnExit>
      <IssueCards issues={issues} />
    </Slide>
  );
}
